import Vue from 'vue';
import { getPassportUrl } from './../../../../utils/other';
import { openChaportChat } from '@/utils/chaport';
import { mapGetters } from 'vuex';
import { getServiceConfigProperty } from '@/constants/services';
export default Vue.extend({
    name: 'doExtendedKyc',
    props: {},
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    methods: {
        goToMyAcc() {
            const url = getPassportUrl('/id/?verification-show=true', { withAcceptor: true });
            window.location.href = String(url);
        },
        handleSupportClick() {
            const vm = this;
            vm.$emit('onClick');
            let content = vm.$t('popups.content.textUsLisa');
            const actions = [{
                    title: 'Чат',
                    isAccent: true,
                    callback() {
                        vm.$store.commit('popupModule/setClosed');
                        openChaportChat({
                            name: vm.getUserData.last_name + ' ' + vm.getUserData.first_name + ' ' + vm.getUserData.patronymic,
                            email: vm.getUserData.email,
                            phone: vm.getUserData.phone,
                            notes: `${vm.$t('popups.content.traderProfile')} ${document.title}`
                        });
                    }
                }];
            if (getServiceConfigProperty('companyAbrv') !== 'LiSA') {
                actions.push({
                    title: 'Telegram',
                    isAccent: false,
                    callback() {
                        vm.$store.commit('popupModule/setClosed');
                        window.open('https://t.me/WhitelistCapital_bot', '_blank');
                    }
                });
                content = vm.$t('popups.content.textUs');
            }
            vm.$store.dispatch('popupModule/openPopup', {
                type: 'confirmPopup',
                letDefaultClose: true,
                title: vm.$t('popups.titles.haveAQuestion'),
                content,
                actions
            });
        }
    }
});
